import { useEffect, useRef } from 'react'

export function useAutoHideControls(
  visible: boolean,
  setVisible: (v: boolean) => void,
  playing: boolean,
  pinned: boolean,
  delayMs = 2800,
) {
  const timer = useRef<number | null>(null)

  const bump = () => {
    setVisible(true)
    if (timer.current) window.clearTimeout(timer.current)
    if (!playing || pinned) return
    timer.current = window.setTimeout(() => setVisible(false), delayMs)
  }

  useEffect(() => {
    if (!playing || pinned) {
      setVisible(true)
      if (timer.current) window.clearTimeout(timer.current)
      return
    }
    bump()
    return () => {
      if (timer.current) window.clearTimeout(timer.current)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playing, pinned])

  return { controlsVisible: visible, bumpControls: bump }
}
